import "./App.css";
import {BrowserRouter, Routes, Route}  from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from "./component/Login";
import LogOut from "./component/LogOut";
import RegisterUser from "./component/RegisterUser";
import EditUser from "./component/EditUser";
import User from "./component/UserList";
import SpvUser from "./component/SpvUserList";
import SpvRegister from "./component/RegisterSpvUser";
import Register from "./component/Dashboard";
import TambahDebitur from "./component/TambahDebitur";
import FormCetak from "./component/FormCetak";
import DetailDebitur from "./component/DetailDebitur";
import Dukcapil from "./component/Dukcapil";
import Error from "./component/Error";
import 'react-image-crop/dist/ReactCrop.css';

import React from 'react'

// import Navbar from "./component/Navbar";
// import SideBar from "./component/sidebar/Sidebar";

function App() {
  return (
    <BrowserRouter>
    <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Routes>
        <Route path="/tambahdebitur" element={<TambahDebitur/>}/>
        <Route path="/detaildebitur/:idDebitur" element={<DetailDebitur/>}/>
        <Route path="/" element={<Register/>}/>
        <Route path="/formcetak" element={<FormCetak/>}/>
        <Route path="/dukcapil" element={<Dukcapil/>}/>
        <Route path="/error" element={<Error/>}/>
        

        <Route path="/login" element={<Login/>}/>
        <Route path="/users/register" element={<RegisterUser/>}/>
        <Route path="/users/logout" element={<LogOut/>}/>
        <Route path="/users" element={<><User/></>}/>
        <Route path="/users/edituser/:idUser" element={<><EditUser/></>}/>

        <Route path="/spvusers" element={<><SpvUser/></>}/>
        <Route path="/spvusers/spvregister" element={<><SpvRegister/></>}/>
      </Routes>
    </BrowserRouter>

  );
}

export default App;
